var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Nav',{staticClass:"nav",attrs:{"navList":_vm.navList}}),_c('div',[_c('router-view')],1),_c('Bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }